import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import axiosRetry from 'axios-retry';
import HeaderReclamo from '../components/reclamos3ro/reclamos/HeaderReclamo';
import { DatosPersonales } from '../components/reclamos3ro/reclamos/DatosPersonales';
import { DocumentosPersonales } from '../components/reclamos3ro/reclamos/DocumentosPersonales';
import StroReclamo from '../components/reclamos3ro/reclamos/StroReclamo';
import { DocumentosOpcionales } from '../components/reclamos3ro/reclamos/DocumentosOpcionales';
import PanelIzqStroLight from '../components/nuevoStro/Light/PanelIzqStroLight';
import PanelIzqStroDark from '../components/nuevoStro/Dark/PanelIzqStroDark';
import Swal from 'sweetalert2';
import './reclamoModalConfirm.css';
axiosRetry(axios, { retries: 3 });
export default function Reclamo({
  reclamo,
  stro,
  planilla,
  setPlanilla,
  denuncia,
  carga4,
  reclamoPanel,
  theme,
  estadoDocs,
  setEstadoDocs,
  obs,
  setObs,
  cargando,
  reclamos,
  reclamoSeleccionadoNuevo,
  setReclamoSeleccionadoNuevo,
  nuevoReclamo,
  setNuevoReclamo,
}) {
  const [cookies] = useCookies(['user']);
  //
  const responsabilidadInput = [
    { label: 'Cr', value: 320 },
    { label: 'Cc', value: 320 },
    { label: 'Sr', value: 300 },
    { label: 'Rp', value: 400 },
    { label: 'Rp1 (1 ruedas)', value: 401 },
    { label: 'Rp2 (2 ruedas)', value: 402 },
    { label: 'Rp3 (3 ruedas)', value: 403 },
    { label: 'Rp4 (4 ruedas)', value: 404 },
    { label: 'Rp5 (5 ruedas)', value: 405 },
    { label: 'Rt', value: 500 },
    { label: 'Ra', value: 550 },
    { label: 'Raf', value: 551 },
    { label: 'Ip', value: 600 },
    { label: 'Dp', value: 800 },
    { label: 'Dt', value: 900 },
    { label: 'Aseg les', value: 100 },
    { label: 'Aseg muerto', value: 130 },
    { label: '3ro les', value: 200 },
    { label: '3ro muerto', value: 230 },
    { label: '3ro muerto Rec', value: 233 },
    { label: 'Rah', value: 590 },
  ];
  //
  const [responsabilidadNueva, setResponsabilidadNueva] = useState('');
  const handleChange1 = event => {
    setResponsabilidadNueva(event.target.value);
  };
  //
  const [asignado, setAsignado] = useState(null);
  const optionsCarga = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'StellaM', label: 'StellaM', key: 3 },
    { value: 'DanielaM', label: 'DanielaM', key: 4 },
    { value: 'rosario', label: 'rosario', key: 5 },
  ];
  const optionsChoque = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Maurom', label: 'Maurom', key: 12 },
    { value: 'ClaudiaF', label: 'ClaudiaF', key: 13 },
    { value: 'Gian', label: 'Gian', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const optionsContractuales = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Augusto', label: 'Augusto', key: 12 },
    { value: 'PaulaC', label: 'PaulaC', key: 13 },
    { value: 'MariaE', label: 'MariaE', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const handleChange2 = event => {
    setAsignado(event.target.value);
  };
  const cargarNuevoReclamo = useCallback(
    async e => {
      e.preventDefault();
      try {
        await axios.post(`https://back.agsseguros.online/api/general/nuevoReclamo`, {
          nroStro: stro.nroStro,
          catStro: responsabilidadNueva,
          asignado: asignado,
        });

        // Recargar la página solo si el POST fue exitoso
        window.location.reload();
      } catch (error) {
        console.error('Error al crear el nuevo reclamo:', error);
        // Podés mostrar una notificación o mensaje al usuario si querés
      }
    },
    [stro?.id, responsabilidadNueva, asignado]
  );
  // tabs state: 'obligatorios', 'opcionales', 'datos'
  const [activeTab, setActiveTab] = useState('obligatorios');
  useEffect(() => {
    setActiveTab('obligatorios');
  }, [reclamoSeleccionadoNuevo]);
  /*const resultado = {
        aprobado: { count: 0, campos: [] },
        devolucion: { count: 0, campos: [] },
        pendiente: { count: 0, campos: [] },
        total: { count: 0 }
    }*/
  const docs = reclamoSeleccionadoNuevo?.reclamo3ro?.docs || {};
  const estadosExcluidos = [
    'estadoVtv',
    'estadoDenunciaPolicial',
    'estadoFormulario08',
    'estadoDanioPropiedad',
    'estadoFotosAseguradoAGS',
    'estadoNoDestruccionTotal',
    'estadoCroquis',
    'estadoCartaFranquicia',
  ];
  const resultado = {
    aprobado: { count: 0, campos: [] },
    devolucion: { count: 0, campos: [] },
    pendiente: { count: 0, campos: [] },
    devuelto: { count: 0, campos: [] },
    total: { count: 0 },
  };
  for (const [campo, valor] of Object.entries(docs)) {
    if (estadosExcluidos.includes(campo)) continue;
    switch (valor) {
      case 905:
        resultado.devuelto.count++;
        resultado.devuelto.campos.push(campo);
        resultado.total.count++;
        break;
      case 904:
        resultado.aprobado.count++;
        resultado.aprobado.campos.push(campo);
        resultado.total.count++;
        break;
      case 903:
        resultado.devolucion.count++;
        resultado.devolucion.campos.push(campo);
        resultado.total.count++;
        break;
      case 902:
        resultado.pendiente.count++;
        resultado.pendiente.campos.push(campo);
        resultado.total.count++;
        break;
      default:
        break;
    }
  }
  //
  const resultadoOpcional = {
    aprobado: { count: 0, campos: [] },
    devolucion: { count: 0, campos: [] },
    devuelto: { count: 0, campos: [] },
    pendiente: { count: 0, campos: [] },
    total: { count: 0 },
  };
  const estadosPermitidos = [
    'estadoVtv',
    'estadoDenunciaPolicial',
    'estadoFormulario08',
    'estadoDanioPropiedad',
    'estadoFotosAseguradoAGS',
    'estadoNoDestruccionTotal',
    'estadoCroquis',
    'estadoCartaFranquicia',
  ];
  for (const [campo, valor] of Object.entries(docs)) {
    // Filtrar los campos que no estén en la lista de estadosPermitidos
    if (!estadosPermitidos.includes(campo)) continue;
    // Lógica de aprobación, devolución y pendiente
    if (valor === 904) {
      resultadoOpcional.aprobado.count++;
      resultadoOpcional.aprobado.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 903) {
      resultadoOpcional.devolucion.count++;
      resultadoOpcional.devolucion.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 902) {
      resultadoOpcional.pendiente.count++;
      resultadoOpcional.pendiente.campos.push(campo);
      resultadoOpcional.total.count++;
    } else if (valor === 905) {
      resultadoOpcional.devuelto.count++;
      resultadoOpcional.devuelto.campos.push(campo);
      resultadoOpcional.total.count++;
    }
  }
  function alMenosUnoEs903(estadoDocs, obs) {
    const obsSafe = obs || {};
    // Filtramos solo los que están en 903
    const campos903 = Object.keys(estadoDocs).filter(key => estadoDocs[key] === 903);
    if (campos903.length === 0) return false; // no hay ninguno en 903 → botón disabled
    // Verificamos que TODOS los que son 903 tengan obs cargado
    return campos903.every(key => obsSafe[key] != null && obsSafe[key].trim() !== '');
  }
  function todosSon904(estadoDocs) {
    return Object.values(estadoDocs).every(valor => valor === 904);
  }
  //
  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  const formattedDate = day + '/' + month + '/' + year;
  function getCurrentTime() {
    const now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return hour + ':' + minute;
  }
  const currentTime = getCurrentTime();
  // estado
  const [estadoStro, setEstadoStro] = useState(reclamoSeleccionadoNuevo?.estado);
  useEffect(() => {
    setEstadoStro(reclamoSeleccionadoNuevo?.estado);
  }, [reclamoSeleccionadoNuevo]);
  const handleEstadoChange = e => {
    setEstadoStro(Number(e.target.value));
  };
  //carpeta armada
  const [carpetaArmada, setCarpetaArmada] = useState(0);
  useEffect(() => {
    setCarpetaArmada(reclamoSeleccionadoNuevo?.reclamo3ro?.docOffice ?? 0);
  }, [reclamoSeleccionadoNuevo]);
  const handleCarpetaArmadaChange = e => {
    setCarpetaArmada(Number(e.target.value));
  };
  // fecha recepcion
  const [fechaRecepcion, setFechaRecepcion] = useState('');
  useEffect(() => {
    if (reclamoSeleccionadoNuevo?.valores?.[301]?.fechaRecepcionReclamoRecibido) {
      setFechaRecepcion(reclamoSeleccionadoNuevo.valores[301].fechaRecepcionReclamoRecibido);
    }
  }, [reclamoSeleccionadoNuevo]);
  const handleChange = e => {
    const valor = e.target.value;
    setFechaRecepcion(valor);
  };
  /* fecha enviado cotizar */
  const [fechaCotizar, setFechaCotizar] = useState('');
  useEffect(() => {
    if (reclamoSeleccionadoNuevo?.valores?.[302]?.fechaEnviadoCotizar) {
      setFechaCotizar(reclamoSeleccionadoNuevo.valores[302].fechaEnviadoCotizar);
    }
  }, [reclamoSeleccionadoNuevo]);
  const handleChangeCotizar = e => {
    const valor = e.target.value;
    setFechaCotizar(valor);
  };
  // actualizar
  const handleGuardarDocumentos = async () => {
    function getFechaFormateada() {
      const ahora = new Date();
      const dia = ahora.getDate();
      const mes = ahora.getMonth() + 1;
      const anio = ahora.getFullYear();
      const horas = ahora.getHours();
      const minutos = ahora.getMinutes();
      const segundos = ahora.getSeconds();
      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }
    const fecha = getFechaFormateada();
    try {
      Swal.fire({
        title: 'Actualizando...',
        text: 'Por favor, espera',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await axios.post('https://back.agsseguros.online/api/prueba/actualizarDocumentacionReclamoDesdeEmpleados', {
        idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        fecha,
        estadoDocs: estadoDocs,
        observacionesDocs: obs,
      });
      await axios.post('https://back.agsseguros.online/api/prueba/actualizarEstadoReclamo3ro', {
        idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        estado: estadoStro,
      });
      await axios.post('https://back.agsseguros.online/api/prueba/actualizarCarpetaArmadaReclamo3ro', {
        idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        carpetaArmada: carpetaArmada,
      });
      if (alMenosUnoEs903(estadoDocs)) {
        await axios.post('https://back.agsseguros.online/api/prueba/actualizarEstadoDevolucionDesdeEmpleados', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        });
      }
      const textoObs =
        reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PEATON' || reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
          ? reclamoSeleccionadoNuevo.reclamo3ro?.nombreReclamante
          : reclamoSeleccionadoNuevo?.reclamo3ro?.patenteRec
            ? reclamoSeleccionadoNuevo.reclamo3ro?.patenteRec
            : responsabilidadInput.find(item => item.value === reclamoSeleccionadoNuevo.catStro)?.label || reclamoSeleccionadoNuevo.catStro;
      if (estadoStro !== reclamoSeleccionadoNuevo?.estado || carpetaArmada !== (reclamoSeleccionadoNuevo?.reclamo3ro?.docOffice ?? 0)) {
        axios.post('https://back.agsseguros.online/api/cronologia', {
          id: denuncia.id,
          desc: `El reclamo ${textoObs} fue actualizado. Estado: ${estadoStro == 301 ? 'RECLAMO RECIBIDO' : estadoStro == 302 ? 'ENVIADO A COTIZAR' : 'SIN MODIFICAR'}. Carpeta Armada: ${
            carpetaArmada == 1 ? 'SI' : 'NO'
          }.`,
          obs: '',
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: 'STRO',
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        });
      }
      Swal.fire({
        icon: 'success',
        title: 'Documentación Actualizada',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error('Error al guardar documentación:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al guardar',
      });
    }
  };
  // informar
  const handleInformarDocumentos = async () => {
    const totalDocs = Object.values(docsSeleccionados).reduce((sum, carpeta) => sum + Object.keys(carpeta).length, 0);
    const { isConfirmed } = await Swal.fire({
      title: '¿Está seguro de informar al tercero?',
      html: `${totalDocs > 0 ? `Hay ${totalDocs} documento${totalDocs > 1 ? 's' : ''} para eliminar.` : 'No hay documentos para eliminar.'}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, informar',
      cancelButtonText: 'Cancelar',
    });
    function getFechaFormateada() {
      const ahora = new Date();
      const dia = ahora.getDate();
      const mes = ahora.getMonth() + 1;
      const anio = ahora.getFullYear();
      const horas = ahora.getHours();
      const minutos = ahora.getMinutes();
      const segundos = ahora.getSeconds();
      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }
    const fecha = getFechaFormateada();
    //
    const textoObs =
      reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PEATON' || reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
        ? reclamoSeleccionadoNuevo.reclamo3ro?.nombreReclamante
        : reclamoSeleccionadoNuevo?.reclamo3ro?.patenteRec
          ? reclamoSeleccionadoNuevo.reclamo3ro?.patenteRec
          : responsabilidadInput.find(item => item.value === reclamoSeleccionadoNuevo.catStro)?.label || reclamoSeleccionadoNuevo.catStro;
    //
    const today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    const year = today.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    const formattedDate = day + '/' + month + '/' + year;
    function getCurrentTime() {
      const now = new Date();
      let hour = now.getHours();
      let minute = now.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      return hour + ':' + minute;
    }
    const currentTime = getCurrentTime();
    const campos903 = Object.keys(estadoDocs).filter(key => estadoDocs[key] === 903);
    const textoCampos = campos903.join(', ');
    if (!isConfirmed) return;
    if (totalDocs > 0) {
      try {
        await axios.delete(`https://reclamosback.agsseguros.online/apiReclamos/documentacion/doc/eliminar/${reclamoSeleccionadoNuevo.reclamo3ro.id}`, {
          data: { docsSeleccionados },
        });
        await axios.post('https://back.agsseguros.online/api/cronologia', {
          id: denuncia.id,
          desc: `Se ha borrado documentación adjuntada en el reclamo ${textoObs}`,
          obs: '',
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: 'STRO',
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        });
        Swal.fire('Eliminados', `${totalDocs} documento${totalDocs > 1 ? 's' : ''} eliminados`, 'success');
      } catch (error) {
        Swal.fire('Error', 'No se pudo eliminar los documentos', 'error');
        console.error(error);
        return;
      }
    }
    try {
      Swal.fire({
        title: 'Actualizando...',
        text: 'Por favor, espera',
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });
      await Promise.all([
        axios.post('https://back.agsseguros.online/api/prueba/actualizarDocumentacionReclamoDesdeEmpleados', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          fecha,
          estadoDocs,
          observacionesDocs: obs,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarEstadoDevolucionDesdeEmpleados', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        }),
        axios.post('https://back.agsseguros.online/api/mail/devolucionReclamoTercero', {
          reclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarEstadoReclamo3ro', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          estado: estadoStro,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarCarpetaArmadaReclamo3ro', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          carpetaArmada,
        }),
        axios.post('https://back.agsseguros.online/api/cronologia', {
          id: denuncia.id,
          desc: `Se han realizado devoluciones en el reclamo ${textoObs} en los campos: ${textoCampos}`,
          obs: '',
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: 'STRO',
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        }),
      ]);
      Swal.fire({
        icon: 'success',
        title: 'Documentación Actualizada',
        confirmButtonText: 'Aceptar',
      }).then(() => window.location.reload());
    } catch (error) {
      console.error('Error al guardar documentación:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al guardar',
      });
    }
  };
  // completar
  const [modalConfirm, setModalConfirm] = useState(0);
  const handleCompletarDocumentos = async () => {
    function getFechaFormateada() {
      const ahora = new Date();
      const dia = ahora.getDate();
      const mes = ahora.getMonth() + 1;
      const anio = ahora.getFullYear();
      const horas = ahora.getHours();
      const minutos = ahora.getMinutes();
      const segundos = ahora.getSeconds();
      return `${dia}/${mes}/${anio} ${horas}:${minutos}:${segundos}`;
    }
    const fecha = getFechaFormateada();
    //
    const textoObs =
      reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PEATON' || reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
        ? reclamoSeleccionadoNuevo.reclamo3ro?.nombreReclamante
        : reclamoSeleccionadoNuevo?.reclamo3ro?.patenteRec
          ? reclamoSeleccionadoNuevo.reclamo3ro?.patenteRec
          : responsabilidadInput.find(item => item.value === reclamoSeleccionadoNuevo.catStro)?.label || reclamoSeleccionadoNuevo.catStro;
    const textoLog =
      reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PEATON' || reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
        ? reclamoSeleccionadoNuevo.reclamo3ro?.nombreReclamante
        : reclamoSeleccionadoNuevo?.reclamo3ro?.patenteRec;
    //
    const today = new Date();
    let day = today.getDate();
    let month = today.getMonth() + 1;
    const year = today.getFullYear();
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    const formattedDate = day + '/' + month + '/' + year;
    function getCurrentTime() {
      const now = new Date();
      let hour = now.getHours();
      let minute = now.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      return hour + ':' + minute;
    }
    const currentTime = getCurrentTime();
    try {
      Swal.fire({
        title: 'Actualizando...',
        text: 'Por favor, espera',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      await Promise.all([
        axios.post('https://back.agsseguros.online/api/prueba/actualizarDocumentacionReclamoDesdeEmpleados', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          fecha,
          estadoDocs: estadoDocs,
          observacionesDocs: obs,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/completarDocumentacionReclamoDesdeEmpleados', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          carpetaArmada: Number(carpetaArmada),
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarEstadoReclamo3ro', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          estado: estadoStro,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarCarpetaArmadaReclamo3ro', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          carpetaArmada: carpetaArmada,
        }),
        axios.post('https://back.agsseguros.online/api/prueba/actualizarFechaRecepcionReclamoRecibidoReclamo3ro', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          fechaRecepcion: fechaRecepcion,
          fechaEnviadoCotizar: fechaCotizar,
        }),
        axios.post('https://back.agsseguros.online/api/mail/aceptacionReclamo', {
          reclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
        }),
        axios.post('https://reclamosback.agsseguros.online/apiReclamos/files/reclamoCompletoSharepoint', {
          idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
          uuid: reclamoSeleccionadoNuevo.reclamo3ro.uuid,
          nroStro: reclamoSeleccionadoNuevo.reclamo3ro.nroStro,
          idUser: reclamoSeleccionadoNuevo.reclamo3ro.id3ro,
          patente3ro: textoLog,
        }),
        axios.post('https://back.agsseguros.online/api/cronologia', {
          id: denuncia.id,
          desc: `El reclamo ${textoObs} fue aceptado y se ha marcado con estado: ${estadoStro == 301 ? 'RECLAMO RECIBIDO' : estadoStro == 302 ? 'ENVIADO A COTIZAR' : 'SIN ESTADO'}. Carpeta Armada: ${
            carpetaArmada == 1 ? 'SI' : 'NO'
          }.`,
          obs: '',
          jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
          motivo: 'STRO',
          autor: cookies.user.usuario,
          fecha: formattedDate,
          hora: currentTime,
        }),
      ]);
      /*
      (async () => {
        try {
          await axios.post('https://reclamosback.agsseguros.online/apiReclamos/sharepoint/subirArchivosSharepoint', {
            idReclamo: reclamoSeleccionadoNuevo.reclamo3ro.id,
            uuid: reclamoSeleccionadoNuevo.reclamo3ro.uuid,
          });
        } catch (err) {
          console.error('Error enviando a SharePoint en background:', err);
        }
      })();
      */
      Swal.fire({
        icon: 'success',
        title: 'Documentación Actualizada',
        text: 'El reclamo fue completado correctamente',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error('Error al guardar documentación:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error al guardar',
      });
    }
  };
  // eliminar
  const [modoEliminar, setModoEliminar] = useState(false);
  const [docsSeleccionados, setDocsSeleccionados] = useState({});
  const confirmarYEliminarDocs = async (reclamoId, docsSeleccionados) => {
    const totalDocs = Object.values(docsSeleccionados).reduce((sum, carpeta) => {
      return sum + Object.keys(carpeta).length;
    }, 0);
    if (totalDocs === 0) {
      Swal.fire('No hay documentos seleccionados', '', 'info');
      return;
    }
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmar eliminación',
      text: `¿Estás seguro que deseas eliminar ${totalDocs} documento${totalDocs > 1 ? 's' : ''}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!isConfirmed) return;
    const textoObs =
      reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PEATON' || reclamoSeleccionadoNuevo?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
        ? reclamoSeleccionadoNuevo.reclamo3ro?.nombreReclamante
        : reclamoSeleccionadoNuevo?.reclamo3ro?.patenteRec
          ? reclamoSeleccionadoNuevo.reclamo3ro?.patenteRec
          : responsabilidadInput.find(item => item.value === reclamoSeleccionadoNuevo.catStro)?.label || reclamoSeleccionadoNuevo.catStro;
    try {
      const { data } = await axios.delete(`https://reclamosback.agsseguros.online/apiReclamos/documentacion/doc/eliminar/${reclamoId}`, { data: { docsSeleccionados } });
      await axios.post('https://back.agsseguros.online/api/cronologia', {
        id: denuncia.id,
        desc: `Se ha borrado documentación adjuntada en el reclamo ${textoObs}`,
        obs: '',
        jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
        motivo: 'STRO',
        autor: cookies.user.usuario,
        fecha: formattedDate,
        hora: currentTime,
      });
      Swal.fire('Eliminados', data.message || 'Documentos eliminados', 'success');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      Swal.fire('Error', 'No se pudo conectar con el servidor', 'error');
      console.error(error);
    }
  };
  // transferir reclamo
  const buscarStro = async stro => {
    Swal.fire({
      title: 'Buscando...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
    try {
      const res = await axios.get('https://back.agsseguros.online/api/prueba/buscarStroTransferir', {
        params: { nroStro: `300${stro}` },
      });
      const data = res.data;
      const result = await Swal.fire({
        title: 'Reclamo encontrado',
        html: `
        <b>Stro:</b> ${String(data.nroStro).substring(3)}<br/>
        <b>Póliza:</b> ${data.pza}<br/>
        <b>Denuncia:</b> ${data.entryId}<br/>
        <b>Fecha Stro:</b> ${data.fechaStro}<br/>
        <b>Asegurado:</b> ${data.nombreAseg}<br/>
        <b>Patente Aseg:</b> ${data.dom}<br/>
        <b>Tipo Stro:</b> ${data.tipoStro}<br/>
      `,
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: 'Transferir',
        cancelButtonText: 'Cancelar',
      });
      // Si
      if (result.isConfirmed) {
        try {
          const idReclamo = reclamoSeleccionadoNuevo.reclamo3ro.id;
          const nroStroNuevo = stro;
          Swal.fire({
            title: 'Transfiriendo reclamo...',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
          await axios.post('https://back.agsseguros.online/api/prueba/transferirReclamo', {
            nroStroNuevo,
            idReclamo,
          });
          await axios.post('https://back.agsseguros.online/api/cronologia', {
            id: denuncia.id,
            desc: `El reclamo fue transferido al STRO ${nroStroNuevo}`,
            obs: '',
            jerarquia: cookies.user.depto === 'cargas' ? 'CRG' : 'DEN',
            motivo: 'STRO',
            autor: cookies.user.usuario,
            fecha: formattedDate,
            hora: currentTime,
          });
          Swal.fire('Éxito', 'El reclamo fue transferido correctamente', 'success');
          window.location.reload();
        } catch (err) {
          console.error('ERROR TRANSFERENCIA:', err);
          Swal.fire('Error', 'No se pudo transferir el reclamo', 'error');
        }
      }
    } catch (e) {
      if (e.response?.status === 404) {
        Swal.fire('Sin resultados', 'No se encontró el STRO', 'warning');
      } else {
        Swal.fire('Error', 'No se pudo procesar la solicitud', 'error');
      }
    }
  };
  const abrirTransferir = async () => {
    const { value: stro } = await Swal.fire({
      title: 'Transferir Reclamo',
      input: 'text',
      inputLabel: 'Buscar nro STRO',
      showCancelButton: true,
      confirmButtonText: 'Buscar',
      cancelButtonText: 'Cancelar',
      inputValidator: value => {
        if (!value) return 'Ingresá un número de STRO';
      },
    });
    if (stro) {
      buscarStro(stro);
    }
  };
  //
  return (
    <>
      <main className={theme === 1 ? 'contenedorStroLight' : 'contenedorStroDark'}>
        <header className='headerStroDarkParaReclamo'>
          <div className='d-flex gap-3'>
            {reclamos.map((r, index) => {
              const texto =
                r?.reclamo3ro?.tipoReclamante === 'PEATON' || r?.reclamo3ro?.tipoReclamante === 'PROPIEDAD'
                  ? r.reclamo3ro?.nombreReclamante
                  : r?.patente3ro
                    ? r.patente3ro
                    : responsabilidadInput.find(item => item.value === r.catStro)?.label || r.catStro;
              const textoCorto = texto?.length > 10 ? texto.slice(0, 10) + '...' : texto;
              return (
                <button key={index} className={reclamoSeleccionadoNuevo?.id === r.id ? 'reclamosSeleccionado' : 'reclamosSeleccion'} onClick={() => setReclamoSeleccionadoNuevo(index)}>
                  {textoCorto}
                </button>
              );
            })}
            <button className='cargarNuevoReclamoSeleccion' onClick={() => setNuevoReclamo(1)}>
              +
            </button>
          </div>
          {reclamoSeleccionadoNuevo?.reclamo3ro ? (
            <div>
              <div>
                Estado:{' '}
                {(() => {
                  const estado = reclamoSeleccionadoNuevo?.reclamo3ro?.estado;
                  const listaEstados = reclamoSeleccionadoNuevo?.estados || [];
                  let texto = '';
                  let colorFondo = '';
                  let colorTexto = '#fff';

                  if (estado === 904) {
                    const estadoEncontrado = listaEstados.find(e => e.id === reclamoSeleccionadoNuevo?.estado);
                    texto = estadoEncontrado?.nombre || '';
                    colorFondo = estadoEncontrado?.hexa || '#82f1cd';
                  } else {
                    switch (estado) {
                      case 901:
                        texto = 'SIN CARGAR';
                        colorFondo = '#cccccc';
                        colorTexto = '#000';
                        break;
                      case 902:
                        texto = 'PENDIENTE DE APROBACION';
                        colorFondo = '#82c1f1';
                        colorTexto = '#1631b9';
                        break;
                      case 903:
                        texto = 'DEVOLUCIÓN';
                        colorFondo = '#fbaf84';
                        break;
                      case 904:
                        texto = 'CARGADA';
                        colorFondo = '#82f1cd';
                        colorTexto = '#29ac8d';
                        break;
                      case 905:
                        texto = 'REINGRESO';
                        colorFondo = '#8e44ad';
                        break;
                      default:
                        texto = '';
                        colorFondo = '#bdbdbd';
                    }
                  }
                  return (
                    <span
                      style={{
                        backgroundColor: colorFondo,
                        color: colorTexto,
                        borderRadius: '8px',
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '22px',
                        fontFamily: 'Poppins, sans-serif',
                        height: '20px',
                        width: 'fit-content',
                        padding: '0 8px',
                        textAlign: 'center',
                        display: 'inline-block',
                      }}>
                      {texto}
                    </span>
                  );
                })()}
              </div>
              <div>
                Texto:{' '}
                {reclamoSeleccionadoNuevo?.reclamo3ro?.estado === 904
                  ? (() => {
                      const listaEstados = reclamoSeleccionadoNuevo?.estados || [];
                      const estadoEncontrado = listaEstados.find(e => e.id === reclamoSeleccionadoNuevo?.estado);
                      return estadoEncontrado?.texto || '';
                    })()
                  : ''}
              </div>
            </div>
          ) : null}
          {/* 
                    <div className="w-100" style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <button className="botonVistaReclamosStroLight" onClick={() => setPlanilla(0)}>VISTA RECLAMO</button>
                        </div>
                    </div>
                    */}
        </header>
        {nuevoReclamo ? (
          <>
            <div className='overlayOscuro' onClick={() => setNuevoReclamo(0)} />
            <form className='nuevoReclamoContainer' onSubmit={cargarNuevoReclamo}>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='nuevoReclamoTitulo'>INGRESAR TIPO DE SINIESTRO</div>
                <button className='btnAgregarNuevoReclamo gap-2' type='submit'>
                  Agregar<i class='bi bi-caret-right-fill'></i>
                </button>
              </div>
              <div style={{ marginTop: '15px' }}>
                <span className='reclamoSpan'>Tipo de siniestro</span>
                <select value={responsabilidadNueva} onChange={handleChange1} className='inputNuevoReclamo' required>
                  <option value=''> </option>
                  {responsabilidadInput.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ marginTop: '15px' }}>
                <span className='reclamoSpan'>Asignado a (opcional)</span>
                <select value={asignado} onChange={handleChange2} className='inputNuevoReclamo'>
                  <option value=''></option>
                  {cookies.user.depto === 'cargas' ? (
                    optionsCarga.map(option => (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  ) : cookies.user.depto === 'choques' ? (
                    optionsChoque.map(option => (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  ) : cookies.user.depto === 'contractuales' ? (
                    optionsContractuales.map(option => (
                      <option key={option.key} value={option.value}>
                        {option.label}
                      </option>
                    ))
                  ) : (
                    <></>
                  )}
                </select>
              </div>
            </form>
          </>
        ) : null}
        {cargando ? (
          <main className='mainStroLight'>
            <PanelIzqStroLight stro={denuncia} carga4={carga4} reclamo={reclamoPanel} planilla={planilla} setPlanilla={setPlanilla} />
            {reclamoSeleccionadoNuevo.reclamo3ro?.archivos ? (
              <section className='d-flex gap-3 w-100' style={{ marginLeft: '280px', paddingRight: '32px', height: '100%', overflow: 'hidden', paddingBottom: '20px' }}>
                <section className='w-100' style={{ height: '100%', overflowY: 'auto', paddingRight: '8px' }}>
                  <div className='reclamo-tabs'>
                    <button
                      type='button'
                      className={`reclamo-tab ${activeTab === 'obligatorios' ? 'active' : ''}`}
                      onClick={() => setActiveTab('obligatorios')}
                    >
                      Doc. Obligatoria
                      <span className='reclamo-tab-badge'>{resultado.total.count}/7</span>
                    </button>
                    <button
                      type='button'
                      className={`reclamo-tab ${activeTab === 'opcionales' ? 'active' : ''}`}
                      onClick={() => setActiveTab('opcionales')}
                    >
                      Doc. Opcional
                      <span className='reclamo-tab-badge'>{resultadoOpcional.total.count}/8</span>
                    </button>
                    <button
                      type='button'
                      className={`reclamo-tab ${activeTab === 'datos' ? 'active' : ''}`}
                      onClick={() => setActiveTab('datos')}
                    >
                      Datos Personales
                    </button>
                  </div>
                  <div className='reclamo-tab-content'>
                    {activeTab === 'obligatorios' && (
                      <DocumentosPersonales
                        reclamo={reclamoSeleccionadoNuevo?.reclamo3ro}
                        setPestania={null}
                        theme={theme}
                        estadoDocs={estadoDocs}
                        setEstadoDocs={setEstadoDocs}
                        obs={obs}
                        setObs={setObs}
                        modoEliminar={modoEliminar}
                        docsSeleccionados={docsSeleccionados}
                        setDocsSeleccionados={setDocsSeleccionados}
                        setModoEliminar={setModoEliminar}
                      />
                    )}
                    {activeTab === 'opcionales' && (
                      <DocumentosOpcionales
                        reclamo={reclamoSeleccionadoNuevo?.reclamo3ro}
                        setPestania={null}
                        theme={theme}
                        estadoDocs={estadoDocs}
                        setEstadoDocs={setEstadoDocs}
                        obs={obs}
                        setObs={setObs}
                        modoEliminar={modoEliminar}
                        docsSeleccionados={docsSeleccionados}
                        setDocsSeleccionados={setDocsSeleccionados}
                        setModoEliminar={setModoEliminar}
                      />
                    )}
                    {activeTab === 'datos' && (
                      <DatosPersonales
                        reclamo={reclamoSeleccionadoNuevo?.reclamo3ro}
                        setPestania={null}
                        theme={theme}
                      />
                    )}
                  </div>
                </section>
                <section className='w-75' style={{ height: '100%', overflowY: 'auto', paddingRight: '8px' }}>
                  <StroReclamo stro={stro} theme={theme} />
                  {reclamoSeleccionadoNuevo?.reclamo3ro?.linkSharepoint ? (
                    <div style={{ marginTop: '20px' }}>
                      <a href={reclamoSeleccionadoNuevo?.reclamo3ro?.linkSharepoint} target='_blank' rel='noopener noreferrer'>
                        Documentación Reclamo
                      </a>
                    </div>
                  ) : null}
                  <select value={estadoStro} onChange={handleEstadoChange} className='form-select w-50' style={{ marginTop: '20px' }} disabled={cookies?.user?.titulo === 'lector'}>
                    {![301, 302].includes(String(estadoStro)) && <option value={reclamoSeleccionadoNuevo.estado}>Estado: {reclamoSeleccionadoNuevo?.estadoData?.nombre ?? 'Sin Estado'}</option>}
                    <option value={301}>RECLAMO RECIBIDO</option>
                    <option value={302}>ENVIADO A COTIZAR</option>
                    <option value={312}>DERIVADO A INSPECCIÓN</option>
                  </select>
                  <div style={{ marginTop: '20px' }}>
                    <select value={carpetaArmada} disabled={cookies?.user?.titulo === 'lector'} onChange={handleCarpetaArmadaChange} className='form-select w-50' style={{ marginTop: '20px' }}>
                      <option value={1}>CARPETA ARMADA: SI</option>
                      <option value={0}>CARPETA ARMADA: NO</option>
                    </select>
                  </div>
                  <div className='reclamo-actions'>
                    <button className='reclamo-btn reclamo-btn-teal' onClick={() => handleGuardarDocumentos()} disabled={cookies?.user?.titulo === 'lector'}>
                      <i className='bi bi-arrow-clockwise'></i> Actualizar
                    </button>
                    <button className='reclamo-btn reclamo-btn-green' onClick={() => setModalConfirm(1)} disabled={!todosSon904(estadoDocs)}>
                      <i className='bi bi-check-circle-fill'></i> Completar
                    </button>
                    <button className='reclamo-btn reclamo-btn-amber' onClick={() => handleInformarDocumentos()} disabled={!alMenosUnoEs903(estadoDocs, obs)}>
                      <i className='bi bi-envelope-fill'></i> Informar
                    </button>
                    <button className={modoEliminar ? 'd-none' : 'reclamo-btn reclamo-btn-danger-outline'} onClick={() => setModoEliminar(!modoEliminar)}>
                      <i className='bi bi-trash'></i> Eliminar Documentos
                    </button>
                    {(cookies.user.id === 1 || cookies.user.id === 53 || cookies.user.id === 34 || cookies.user.id === 69) && (
                      <button className={modoEliminar ? 'd-none' : 'reclamo-btn reclamo-btn-danger-outline'} onClick={abrirTransferir}>
                        <i className='bi bi-arrow-left-right'></i> Transferir Reclamo
                      </button>
                    )}
                    {modoEliminar && (cookies.user.id === 1 || cookies.user.id === 53 || cookies.user.id === 34 || cookies.user.id === 69) ? (
                      <div className='d-flex gap-2' style={{ marginLeft: 'auto' }}>
                        <button className='reclamo-btn reclamo-btn-danger' onClick={() => confirmarYEliminarDocs(reclamoSeleccionadoNuevo.reclamo3ro.id, docsSeleccionados)}>
                          <i className='bi bi-trash-fill'></i> Eliminar Documentos
                        </button>
                        <button
                          className='reclamo-btn reclamo-btn-secondary'
                          onClick={() => {
                            setModoEliminar(false);
                            setDocsSeleccionados({});
                          }}>
                          <i className='bi bi-x-circle'></i> Cancelar
                        </button>
                      </div>
                    ) : null}
                  </div>
                  {Object.values(estadoDocs).includes(903) && !alMenosUnoEs903(estadoDocs, obs) ? (
                    <p className='reclamo-warning'>
                      <i className='bi bi-exclamation-triangle-fill'></i> Para informar, todas las observaciones de los documentos en devolución deben estar cargadas
                    </p>
                  ) : null}
                </section>
              </section>
            ) : (
              <div className='w-100 d-flex' style={{ marginLeft: '280px', marginTop: '100px', flexDirection: 'column', alignItems: 'center' }}>
                <div className='spinner-border text-success center' role='status'></div>
                <h4 className='fst-italic'>Cargando Informacion de Reclamos</h4>
              </div>
            )}
          </main>
        ) : (
          <div className='center pt-5'>
            <div class='spinner-border text-success center' role='status'></div>
          </div>
        )}
        {modalConfirm && (
          <>
            <div className='modal-backdrop'></div>
            <div className='modal-container'>
              <h3 className='text-center'>CONFIRMAR RECEPCION DE RECLAMO</h3>
              <p className='text-center'>Se le enviara un correo de confirmacion al tercero y el estado del reclamo sera el estado seleccionado a continuacion</p>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  handleCompletarDocumentos();
                }}
                style={{ marginTop: '20px' }}>
                <div>
                  <label>ESTADO DE SINIESTRO*</label>
                  <select value={estadoStro} onChange={e => setEstadoStro(e.target.value)} required className='form-select'>
                    <option value=''>--Seleccione un estado--</option>
                    <option value={301}>RECLAMO RECIBIDO</option>
                    <option value={302}>ENVIADO A COTIZAR</option>
                  </select>
                </div>
                <div className='mt-3'>
                  <label>CARPETA ARMADA*</label>
                  <select value={carpetaArmada} onChange={e => setCarpetaArmada(e.target.value)} required className='form-select'>
                    <option value=''>--Seleccione--</option>
                    <option value={1}>Sí</option>
                    <option value={0}>No</option>
                  </select>
                </div>
                <div className='mt-3'>
                  <label>Fecha de Recepción Reclamo Recibido:</label>
                  <input type='date' value={fechaRecepcion} onChange={handleChange} className='form-control' />
                </div>
                <div className='mt-3'>
                  <label>Fecha Enviado a Cotizar:</label>
                  <input type='date' value={fechaCotizar} onChange={handleChangeCotizar} className='form-control' />
                </div>
                <div className='center gap-4 mt-4'>
                  <button className='btn btn-secondary' onClick={() => setModalConfirm(0)}>
                    Cancelar
                  </button>
                  <button className='btn btn-primary' type='submit'>
                    Confirmar
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
      </main>
    </>
  );
}
